<div class="creation-progress-backdrop">
  <section class="creation-progress" aria-live="polite">
    <h2 class="creation-progress-headline">
      <app-loading-spinner></app-loading-spinner>
      {{ 'guidedCourseCreation.progress.headline' | translate }}
    </h2>

    <p class="creation-progress-warning">
      {{ 'guidedCourseCreation.progress.warning' | translate }}
    </p>

    <div class="creation-progress-meter">
      <div class="creation-progress-status">
        <span class="creation-progress-label">
          {{ labelKey() | translate: labelParams() }}
        </span>
        <span class="creation-progress-percent">{{ displayPercent() }}%</span>
      </div>

      <div
        class="creation-progress-bar"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="displayPercent()"
      >
        <div
          class="creation-progress-bar-fill"
          [style.width.%]="displayPercent()"
        ></div>
      </div>
    </div>
  </section>
</div>
